(() => {
  const selector = '[data-kfa-back-to-top]';
  const supportedPageSelector = 'section.okd-grid, section.okd-exhibition-story';

  function initialise() {
    const button = document.querySelector(selector);
    if (!button || !document.querySelector(supportedPageSelector)) return;

    button.hidden = false;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const update = () => {
      const threshold = Math.max(480, window.innerHeight * 0.55);
      const pageIsLong = document.documentElement.scrollHeight > window.innerHeight * 1.35;
      button.classList.toggle('is-visible', pageIsLong && window.scrollY > threshold);
    };

    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(() => {
        update();
        ticking = false;
      });
    };

    button.addEventListener('click', () => {
      window.scrollTo({
        top: 0,
        behavior: reducedMotion.matches ? 'auto' : 'smooth'
      });
    });

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise, { once: true });
  } else {
    initialise();
  }
})();
